import { Item } from "@react-stately/collections";
export { Item };
import { Virtualizer } from "@react-aria/virtualizer";
import { useProvider } from "@react-spectrum/provider";
import { useCollator, useLocale, useMessageFormatter } from "@react-aria/i18n";
import { ProgressCircle } from "@react-spectrum/progress";
import { useHover } from "@react-aria/interactions";
import { useFocusRing } from "@react-aria/focus";
import _react, { useContext, useRef, useMemo } from "react";
import { mergeProps } from "@react-aria/utils";
import { useListState } from "@react-stately/list";
import { ListLayout } from "@react-stately/layout";
import { GridKeyboardDelegate, useGrid, useGridCell, useGridRow } from "@react-aria/grid";
import { GridCollection, useGridState } from "@react-stately/grid";
import { classNames, useDOMRef, useStyleProps } from "@react-spectrum/utils";
import _babelRuntimeHelpersEsmInteropRequireDefault from "@babel/runtime/helpers/esm/interopRequireDefault";
import _babelRuntimeHelpersEsmExtends from "@babel/runtime/helpers/esm/extends";
import "./main.css";

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/list/src/listview.css
var $ebb597d7e6956599eca07e96d462420$exports = {};
$ebb597d7e6956599eca07e96d462420$exports = {
  "react-spectrum-ListView": "_react-spectrum-ListView_49612",
  "react-spectrum-ListViewItem": "_react-spectrum-ListViewItem_49612",
  "is-hovered": "_is-hovered_49612",
  "is-focused": "_is-focused_49612",
  "focus-ring": "_focus-ring_49612",
  "react-spectrum-ListView-centeredWrapper": "_react-spectrum-ListView-centeredWrapper_49612"
};
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/list/intl/ar-AE.json
var $b85ce4af889dd6c3d521a587c1900ce$exports = {};
$b85ce4af889dd6c3d521a587c1900ce$exports = JSON.parse("{\"loading\":\"جار التحميل...\",\"loadingMore\":\"جار تحميل المزيد...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/list/intl/bg-BG.json
var $f9bd76206a32f1e5f95049501e98f982$exports = {};
$f9bd76206a32f1e5f95049501e98f982$exports = JSON.parse("{\"loading\":\"Зареждане...\",\"loadingMore\":\"Зареждане на още...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/list/intl/cs-CZ.json
var $b3c202afa442ab7441e85fe6c9c17b$exports = {};
$b3c202afa442ab7441e85fe6c9c17b$exports = JSON.parse("{\"loading\":\"Načítání...\",\"loadingMore\":\"Načítání dalších...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/list/intl/da-DK.json
var $cb726518541bec80dee545ccee5d8$exports = {};
$cb726518541bec80dee545ccee5d8$exports = JSON.parse("{\"loading\":\"Indlæser ...\",\"loadingMore\":\"Indlæser flere ...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/list/intl/de-DE.json
var $f3c59bef8b03aa544e246afc598cf$exports = {};
$f3c59bef8b03aa544e246afc598cf$exports = JSON.parse("{\"loading\":\"Laden...\",\"loadingMore\":\"Mehr laden ...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/list/intl/el-GR.json
var $bf0bac8fed5f008c5fea0705ee4c9491$exports = {};
$bf0bac8fed5f008c5fea0705ee4c9491$exports = JSON.parse("{\"loading\":\"Φόρτωση...\",\"loadingMore\":\"Φόρτωση περισσότερων...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/list/intl/en-US.json
var $c5670f96e4b56f68645a3f73e33f3b1b$exports = {};
$c5670f96e4b56f68645a3f73e33f3b1b$exports = JSON.parse("{\"loading\":\"Loading…\",\"loadingMore\":\"Loading more…\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/list/intl/es-ES.json
var $ec3e00d035b1adeeb9629bb2e63ec670$exports = {};
$ec3e00d035b1adeeb9629bb2e63ec670$exports = JSON.parse("{\"loading\":\"Cargando…\",\"loadingMore\":\"Cargando más…\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/list/intl/et-EE.json
var $d5d5e8c9bdbf05fe30b91f9d09c105b$exports = {};
$d5d5e8c9bdbf05fe30b91f9d09c105b$exports = JSON.parse("{\"loading\":\"Laadimine...\",\"loadingMore\":\"Laadi rohkem...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/list/intl/fi-FI.json
var $f63b02513f4fa2e33b24779bb246576d$exports = {};
$f63b02513f4fa2e33b24779bb246576d$exports = JSON.parse("{\"loading\":\"Ladataan…\",\"loadingMore\":\"Ladataan lisää…\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/list/intl/fr-FR.json
var $fdf3ec38576fab939834da5f4ce751b$exports = {};
$fdf3ec38576fab939834da5f4ce751b$exports = JSON.parse("{\"loading\":\"Chargement...\",\"loadingMore\":\"Chargement supplémentaire...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/list/intl/he-IL.json
var $c4be854bbfb0f62f0627be06cf8631df$exports = {};
$c4be854bbfb0f62f0627be06cf8631df$exports = JSON.parse("{\"loading\":\"טוען...\",\"loadingMore\":\"טוען עוד...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/list/intl/hr-HR.json
var $d7efbca7550093dc4bacef75b5a1a4$exports = {};
$d7efbca7550093dc4bacef75b5a1a4$exports = JSON.parse("{\"loading\":\"Učitavam...\",\"loadingMore\":\"Učitavam još...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/list/intl/hu-HU.json
var $bb8e1768aa7416bf5f81e846bf6$exports = {};
$bb8e1768aa7416bf5f81e846bf6$exports = JSON.parse("{\"loading\":\"Betöltés folyamatban…\",\"loadingMore\":\"Továbbiak betöltése folyamatban…\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/list/intl/it-IT.json
var $f5b0ed82b6b6173b7821fde8af$exports = {};
$f5b0ed82b6b6173b7821fde8af$exports = JSON.parse("{\"loading\":\"Caricamento...\",\"loadingMore\":\"Caricamento altri...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/list/intl/ja-JP.json
var $c8babc235c2f5405863947540a42d114$exports = {};
$c8babc235c2f5405863947540a42d114$exports = JSON.parse("{\"loading\":\"読み込み中...\",\"loadingMore\":\"さらに読み込み中...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/list/intl/ko-KR.json
var $c20e3c7d8998036371e02f16e8903916$exports = {};
$c20e3c7d8998036371e02f16e8903916$exports = JSON.parse("{\"loading\":\"로드 중\",\"loadingMore\":\"추가 로드 중\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/list/intl/lt-LT.json
var $ae483c709c0388e9340b3940c084f6e$exports = {};
$ae483c709c0388e9340b3940c084f6e$exports = JSON.parse("{\"loading\":\"Įkeliama...\",\"loadingMore\":\"Įkeliama daugiau...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/list/intl/lv-LV.json
var $f664e164342bc5fb300120570ce2ac$exports = {};
$f664e164342bc5fb300120570ce2ac$exports = JSON.parse("{\"loading\":\"Notiek ielāde...\",\"loadingMore\":\"Tiek ielādēts vēl...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/list/intl/nb-NO.json
var $eda9f5aec26d5a4f32b87634d$exports = {};
$eda9f5aec26d5a4f32b87634d$exports = JSON.parse("{\"loading\":\"Laster inn ...\",\"loadingMore\":\"Laster inn flere ...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/list/intl/nl-NL.json
var $d4566582f28d40bb28b61fa439ffe9d$exports = {};
$d4566582f28d40bb28b61fa439ffe9d$exports = JSON.parse("{\"loading\":\"Laden...\",\"loadingMore\":\"Meer laden...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/list/intl/pl-PL.json
var $b52f55f57cf8e85e9bea148521ebbe81$exports = {};
$b52f55f57cf8e85e9bea148521ebbe81$exports = JSON.parse("{\"loading\":\"Ładowanie...\",\"loadingMore\":\"Wczytywanie większej liczby...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/list/intl/pt-BR.json
var $ce84caf8c6cafeca94546ad1b32$exports = {};
$ce84caf8c6cafeca94546ad1b32$exports = JSON.parse("{\"loading\":\"Carregando...\",\"loadingMore\":\"Carregando mais...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/list/intl/pt-PT.json
var $b634896634f9a0e466f643ad9796b88$exports = {};
$b634896634f9a0e466f643ad9796b88$exports = JSON.parse("{\"loading\":\"A carregar...\",\"loadingMore\":\"A carregar mais...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/list/intl/ro-RO.json
var $db4befc046436cf26bbc1e4e9cd54$exports = {};
$db4befc046436cf26bbc1e4e9cd54$exports = JSON.parse("{\"loading\":\"Se încarcă...\",\"loadingMore\":\"Se încarcă mai multe...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/list/intl/ru-RU.json
var $bd45f53368cd48957b7d9d0068e4f5$exports = {};
$bd45f53368cd48957b7d9d0068e4f5$exports = JSON.parse("{\"loading\":\"Загрузка...\",\"loadingMore\":\"Дополнительная загрузка...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/list/intl/sk-SK.json
var $d2f2737dc6babb85bc380b1a2bf09$exports = {};
$d2f2737dc6babb85bc380b1a2bf09$exports = JSON.parse("{\"loading\":\"Načítava sa...\",\"loadingMore\":\"Načítava sa viac...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/list/intl/sl-SI.json
var $eeb3a7903c61400c140262784bb766$exports = {};
$eeb3a7903c61400c140262784bb766$exports = JSON.parse("{\"loading\":\"Nalaganje...\",\"loadingMore\":\"Nalaganje več vsebine...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/list/intl/sr-SP.json
var $d2ad74d8daf20becf3ecd2bf05c65b4$exports = {};
$d2ad74d8daf20becf3ecd2bf05c65b4$exports = JSON.parse("{\"loading\":\"Učitavam...\",\"loadingMore\":\"Učitavam još...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/list/intl/sv-SE.json
var $dcdce261cd753187c50474a7b8f270b3$exports = {};
$dcdce261cd753187c50474a7b8f270b3$exports = JSON.parse("{\"loading\":\"Läser in...\",\"loadingMore\":\"Läser in mer...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/list/intl/tr-TR.json
var $b6016d4e7c60b9c6efab2e245dfc18c$exports = {};
$b6016d4e7c60b9c6efab2e245dfc18c$exports = JSON.parse("{\"loading\":\"Yükleniyor...\",\"loadingMore\":\"Daha fazla yükleniyor...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/list/intl/uk-UA.json
var $f33211f6b6e538f6ea263208c631f$exports = {};
$f33211f6b6e538f6ea263208c631f$exports = JSON.parse("{\"loading\":\"Завантаження…\",\"loadingMore\":\"Завантаження інших об’єктів...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/list/intl/zh-CN.json
var $bb43f9b51eb6e106311801ab5f8f582$exports = {};
$bb43f9b51eb6e106311801ab5f8f582$exports = JSON.parse("{\"loading\":\"正在加载...\",\"loadingMore\":\"正在加载更多...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/list/intl/zh-TW.json
var $c3d5030460fd41d7a5870ddf63de81d5$exports = {};
$c3d5030460fd41d7a5870ddf63de81d5$exports = JSON.parse("{\"loading\":\"正在載入\",\"loadingMore\":\"正在載入更多…\"}");
var $ebb597d7e6956599eca07e96d462420$$interop$default = $parcel$interopDefault($ebb597d7e6956599eca07e96d462420$exports);

function $ac0abb3242b77613ec5573307b88e112$export$ListViewItem(props) {
  let {
    item
  } = props;
  let {
    state
  } = useContext($cef2d30b40f481de186f4529c10639c$export$ListViewContext);
  let ref = useRef();
  let {
    isFocusVisible: isFocusVisibleWithin,
    focusProps: focusWithinProps
  } = useFocusRing({
    within: true
  });
  let {
    isFocusVisible,
    focusProps
  } = useFocusRing();
  let {
    hoverProps,
    isHovered
  } = useHover({});
  let {
    rowProps
  } = useGridRow({
    node: item,
    isVirtualized: true
  }, state, ref);
  let {
    gridCellProps
  } = useGridCell({
    node: item,
    focusMode: 'cell'
  }, state, ref);
  const mergedProps = mergeProps(gridCellProps, hoverProps, focusWithinProps, focusProps);
  return /*#__PURE__*/_react.createElement("div", rowProps, /*#__PURE__*/_react.createElement("div", _babelRuntimeHelpersEsmExtends({
    className: classNames($ebb597d7e6956599eca07e96d462420$$interop$default, 'react-spectrum-ListViewItem', {
      'is-focused': isFocusVisibleWithin,
      'focus-ring': isFocusVisible,
      'is-hovered': isHovered
    }),
    ref: ref
  }, mergedProps), item.rendered));
}

// @ts-ignore
const $cef2d30b40f481de186f4529c10639c$var$intlMessages = {
  "ar-AE": _babelRuntimeHelpersEsmInteropRequireDefault($b85ce4af889dd6c3d521a587c1900ce$exports).default,
  "bg-BG": _babelRuntimeHelpersEsmInteropRequireDefault($f9bd76206a32f1e5f95049501e98f982$exports).default,
  "cs-CZ": _babelRuntimeHelpersEsmInteropRequireDefault($b3c202afa442ab7441e85fe6c9c17b$exports).default,
  "da-DK": _babelRuntimeHelpersEsmInteropRequireDefault($cb726518541bec80dee545ccee5d8$exports).default,
  "de-DE": _babelRuntimeHelpersEsmInteropRequireDefault($f3c59bef8b03aa544e246afc598cf$exports).default,
  "el-GR": _babelRuntimeHelpersEsmInteropRequireDefault($bf0bac8fed5f008c5fea0705ee4c9491$exports).default,
  "en-US": _babelRuntimeHelpersEsmInteropRequireDefault($c5670f96e4b56f68645a3f73e33f3b1b$exports).default,
  "es-ES": _babelRuntimeHelpersEsmInteropRequireDefault($ec3e00d035b1adeeb9629bb2e63ec670$exports).default,
  "et-EE": _babelRuntimeHelpersEsmInteropRequireDefault($d5d5e8c9bdbf05fe30b91f9d09c105b$exports).default,
  "fi-FI": _babelRuntimeHelpersEsmInteropRequireDefault($f63b02513f4fa2e33b24779bb246576d$exports).default,
  "fr-FR": _babelRuntimeHelpersEsmInteropRequireDefault($fdf3ec38576fab939834da5f4ce751b$exports).default,
  "he-IL": _babelRuntimeHelpersEsmInteropRequireDefault($c4be854bbfb0f62f0627be06cf8631df$exports).default,
  "hr-HR": _babelRuntimeHelpersEsmInteropRequireDefault($d7efbca7550093dc4bacef75b5a1a4$exports).default,
  "hu-HU": _babelRuntimeHelpersEsmInteropRequireDefault($bb8e1768aa7416bf5f81e846bf6$exports).default,
  "it-IT": _babelRuntimeHelpersEsmInteropRequireDefault($f5b0ed82b6b6173b7821fde8af$exports).default,
  "ja-JP": _babelRuntimeHelpersEsmInteropRequireDefault($c8babc235c2f5405863947540a42d114$exports).default,
  "ko-KR": _babelRuntimeHelpersEsmInteropRequireDefault($c20e3c7d8998036371e02f16e8903916$exports).default,
  "lt-LT": _babelRuntimeHelpersEsmInteropRequireDefault($ae483c709c0388e9340b3940c084f6e$exports).default,
  "lv-LV": _babelRuntimeHelpersEsmInteropRequireDefault($f664e164342bc5fb300120570ce2ac$exports).default,
  "nb-NO": _babelRuntimeHelpersEsmInteropRequireDefault($eda9f5aec26d5a4f32b87634d$exports).default,
  "nl-NL": _babelRuntimeHelpersEsmInteropRequireDefault($d4566582f28d40bb28b61fa439ffe9d$exports).default,
  "pl-PL": _babelRuntimeHelpersEsmInteropRequireDefault($b52f55f57cf8e85e9bea148521ebbe81$exports).default,
  "pt-BR": _babelRuntimeHelpersEsmInteropRequireDefault($ce84caf8c6cafeca94546ad1b32$exports).default,
  "pt-PT": _babelRuntimeHelpersEsmInteropRequireDefault($b634896634f9a0e466f643ad9796b88$exports).default,
  "ro-RO": _babelRuntimeHelpersEsmInteropRequireDefault($db4befc046436cf26bbc1e4e9cd54$exports).default,
  "ru-RU": _babelRuntimeHelpersEsmInteropRequireDefault($bd45f53368cd48957b7d9d0068e4f5$exports).default,
  "sk-SK": _babelRuntimeHelpersEsmInteropRequireDefault($d2f2737dc6babb85bc380b1a2bf09$exports).default,
  "sl-SI": _babelRuntimeHelpersEsmInteropRequireDefault($eeb3a7903c61400c140262784bb766$exports).default,
  "sr-SP": _babelRuntimeHelpersEsmInteropRequireDefault($d2ad74d8daf20becf3ecd2bf05c65b4$exports).default,
  "sv-SE": _babelRuntimeHelpersEsmInteropRequireDefault($dcdce261cd753187c50474a7b8f270b3$exports).default,
  "tr-TR": _babelRuntimeHelpersEsmInteropRequireDefault($b6016d4e7c60b9c6efab2e245dfc18c$exports).default,
  "uk-UA": _babelRuntimeHelpersEsmInteropRequireDefault($f33211f6b6e538f6ea263208c631f$exports).default,
  "zh-CN": _babelRuntimeHelpersEsmInteropRequireDefault($bb43f9b51eb6e106311801ab5f8f582$exports).default,
  "zh-TW": _babelRuntimeHelpersEsmInteropRequireDefault($c3d5030460fd41d7a5870ddf63de81d5$exports).default
};

const $cef2d30b40f481de186f4529c10639c$export$ListViewContext = /*#__PURE__*/_react.createContext(null);

function $cef2d30b40f481de186f4529c10639c$export$useListLayout(state) {
  let {
    scale
  } = useProvider();
  let collator = useCollator({
    usage: 'search',
    sensitivity: 'base'
  });
  let layout = useMemo(() => new ListLayout({
    estimatedRowHeight: scale === 'large' ? 48 : 32,
    padding: 0,
    collator
  }), [collator, scale]);
  layout.collection = state.collection;
  layout.disabledKeys = state.disabledKeys;
  return layout;
}

function $cef2d30b40f481de186f4529c10639c$var$ListView(props, ref) {
  let {
    transitionDuration = 0
  } = props;
  let domRef = useDOMRef(ref);
  let {
    collection
  } = useListState(props);
  let formatMessage = useMessageFormatter($cef2d30b40f481de186f4529c10639c$var$intlMessages);
  let {
    styleProps
  } = useStyleProps(props);
  let {
    direction
  } = useLocale();
  let collator = useCollator({
    usage: 'search',
    sensitivity: 'base'
  });
  let gridCollection = useMemo(() => new GridCollection({
    columnCount: 1,
    items: [...collection].map(item => ({
      type: 'item',
      childNodes: [_babelRuntimeHelpersEsmExtends({}, item, {
        index: 0,
        type: 'cell'
      })]
    }))
  }), [collection]);
  let state = useGridState(_babelRuntimeHelpersEsmExtends({}, props, {
    collection: gridCollection
  }));
  let layout = $cef2d30b40f481de186f4529c10639c$export$useListLayout(state);
  let keyboardDelegate = useMemo(() => new GridKeyboardDelegate({
    collection: state.collection,
    disabledKeys: state.disabledKeys,
    ref: domRef,
    direction,
    collator,
    focusMode: 'cell'
  }), [state, domRef, direction, collator]);
  let {
    gridProps
  } = useGrid(_babelRuntimeHelpersEsmExtends({}, props, {
    isVirtualized: true,
    keyboardDelegate
  }), state, domRef); // Sync loading state into the layout.

  layout.isLoading = props.isLoading;
  return /*#__PURE__*/_react.createElement($cef2d30b40f481de186f4529c10639c$export$ListViewContext.Provider, {
    value: {
      state,
      keyboardDelegate
    }
  }, /*#__PURE__*/_react.createElement(Virtualizer, _babelRuntimeHelpersEsmExtends({}, gridProps, styleProps, {
    ref: domRef,
    focusedKey: state.selectionManager.focusedKey,
    sizeToFit: "height",
    scrollDirection: "vertical",
    className: classNames($ebb597d7e6956599eca07e96d462420$$interop$default, 'react-spectrum-ListView', styleProps.className),
    layout: layout,
    collection: collection,
    transitionDuration: transitionDuration
  }), (type, item) => {
    if (type === 'item') {
      return /*#__PURE__*/_react.createElement($ac0abb3242b77613ec5573307b88e112$export$ListViewItem, {
        item: item
      });
    } else if (type === 'loader') {
      return /*#__PURE__*/_react.createElement($cef2d30b40f481de186f4529c10639c$var$CenteredWrapper, null, /*#__PURE__*/_react.createElement(ProgressCircle, {
        isIndeterminate: true,
        "aria-label": state.collection.size > 0 ? formatMessage('loadingMore') : formatMessage('loading')
      }));
    } else if (type === 'placeholder') {
      let emptyState = props.renderEmptyState ? props.renderEmptyState() : null;

      if (emptyState == null) {
        return null;
      }

      return /*#__PURE__*/_react.createElement($cef2d30b40f481de186f4529c10639c$var$CenteredWrapper, null, emptyState);
    }
  }));
}

function $cef2d30b40f481de186f4529c10639c$var$CenteredWrapper(_ref) {
  let {
    children
  } = _ref;
  let {
    state
  } = useContext($cef2d30b40f481de186f4529c10639c$export$ListViewContext);
  return /*#__PURE__*/_react.createElement("div", {
    role: "row",
    "aria-rowindex": state.collection.size + 1,
    className: classNames($ebb597d7e6956599eca07e96d462420$$interop$default, 'react-spectrum-ListView-centeredWrapper')
  }, /*#__PURE__*/_react.createElement("div", {
    role: "gridcell"
  }, children));
}

export const ListView = /*#__PURE__*/_react.forwardRef($cef2d30b40f481de186f4529c10639c$var$ListView);
//# sourceMappingURL=module.js.map
